import React from "react";

// Formulaire englobant barre de recherche + panneau de filtres : « Entrée »
// depuis n'importe quel champ lance la recherche.
const ListSearchForm = ({ onSubmit, children, className = "", ...props }) => (
  <form
    className={`list-card list-search ${className}`.trim()}
    role="search"
    onSubmit={(e) => {
      e.preventDefault();
      if (onSubmit) onSubmit();
    }}
    {...props}
  >
    {children}
  </form>
);

export default ListSearchForm;
